import React, { FC, useState, useEffect } from "react";
import { Box, Modal as MuiModal, Typography } from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDButton from "mdComponents/MDButton";
import HostingPlanSelector from "./HostingPlanSelector";

interface LocationChangeSubscriptionPlanModalProps {
  visible: boolean;
  selectedPlanId: number;
  onConfirm: (planId: number) => void;
  onCancel: () => void;
}

const LocationChangeSubscriptionPlanModal: FC<LocationChangeSubscriptionPlanModalProps> = ({
  visible,
  selectedPlanId,
  onConfirm,
  onCancel,
}) => {
  const [tempSelection, setTempSelection] = useState<number>(selectedPlanId);

  useEffect(() => {
    if (visible) setTempSelection(selectedPlanId);
  }, [visible, selectedPlanId]);

  const handleConfirm = () => {
    onConfirm(tempSelection);
  };

  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 500,
          maxWidth: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        {/* Modal Header */}
        <Typography variant="h5" fontWeight="medium" mb={2}>
          Change Hosting Plan
        </Typography>

        {/* Hosting Plan Selector */}
        <HostingPlanSelector
          selectedPlanId={tempSelection}
          onSelectPlan={setTempSelection}
        />

        {/* Action Buttons */}
        <MDBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
          <MDButton variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </MDButton>
          <MDButton variant="contained" color="info" onClick={handleConfirm}>
            Confirm
          </MDButton>
        </MDBox>
      </Box>
    </MuiModal>
  );
};

export default LocationChangeSubscriptionPlanModal;
